var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinesDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_2514_42268)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 0H0V133.333H80V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 6.11843C3.37911 6.11843 6.11842 3.37912 6.11842 1.28746e-05C6.11842 -3.3791 3.37911 -6.11841 1.43051e-06 -6.11841C-3.37911 -6.11841 -6.11842 -3.3791 -6.11842 1.28746e-05C-6.11842 3.37912 -3.37911 6.11843 1.43051e-06 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 0H80V133.333H160V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 6.11843C83.3791 6.11843 86.1184 3.37912 86.1184 1.28746e-05C86.1184 -3.3791 83.3791 -6.11841 80 -6.11841C76.6209 -6.11841 73.8816 -3.3791 73.8816 1.28746e-05C73.8816 3.37912 76.6209 6.11843 80 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 0H160V133.333H240V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 6.11843C163.379 6.11843 166.118 3.37912 166.118 1.28746e-05C166.118 -3.3791 163.379 -6.11841 160 -6.11841C156.621 -6.11841 153.882 -3.3791 153.882 1.28746e-05C153.882 3.37912 156.621 6.11843 160 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 0H240V133.333H320V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 6.11843C243.379 6.11843 246.118 3.37912 246.118 1.28746e-05C246.118 -3.3791 243.379 -6.11841 240 -6.11841C236.621 -6.11841 233.882 -3.3791 233.882 1.28746e-05C233.882 3.37912 236.621 6.11843 240 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 0H320V133.333H400V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 6.11843C323.379 6.11843 326.118 3.37912 326.118 1.28746e-05C326.118 -3.3791 323.379 -6.11841 320 -6.11841C316.621 -6.11841 313.882 -3.3791 313.882 1.28746e-05C313.882 3.37912 316.621 6.11843 320 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 0H400V133.333H480V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 6.11843C403.379 6.11843 406.118 3.37912 406.118 1.28746e-05C406.118 -3.3791 403.379 -6.11841 400 -6.11841C396.621 -6.11841 393.882 -3.3791 393.882 1.28746e-05C393.882 3.37912 396.621 6.11843 400 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 0H480V133.333H560V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 6.11843C483.379 6.11843 486.118 3.37912 486.118 1.28746e-05C486.118 -3.3791 483.379 -6.11841 480 -6.11841C476.621 -6.11841 473.882 -3.3791 473.882 1.28746e-05C473.882 3.37912 476.621 6.11843 480 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 0H560V133.333H640V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 6.11843C563.379 6.11843 566.118 3.37912 566.118 1.28746e-05C566.118 -3.3791 563.379 -6.11841 560 -6.11841C556.621 -6.11841 553.882 -3.3791 553.882 1.28746e-05C553.882 3.37912 556.621 6.11843 560 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 0H640V133.333H720V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 6.11843C643.379 6.11843 646.118 3.37912 646.118 1.28746e-05C646.118 -3.3791 643.379 -6.11841 640 -6.11841C636.621 -6.11841 633.882 -3.3791 633.882 1.28746e-05C633.882 3.37912 636.621 6.11843 640 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 0H720V133.333H800V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 6.11843C723.379 6.11843 726.118 3.37912 726.118 1.28746e-05C726.118 -3.3791 723.379 -6.11841 720 -6.11841C716.621 -6.11841 713.882 -3.3791 713.882 1.28746e-05C713.882 3.37912 716.621 6.11843 720 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 0H800V133.333H880V0Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 6.11843C803.379 6.11843 806.118 3.37912 806.118 1.28746e-05C806.118 -3.3791 803.379 -6.11841 800 -6.11841C796.621 -6.11841 793.882 -3.3791 793.882 1.28746e-05C793.882 3.37912 796.621 6.11843 800 6.11843Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 133.333H0V266.667H80V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 139.452C3.37911 139.452 6.11842 136.712 6.11842 133.333C6.11842 129.954 3.37911 127.215 1.43051e-06 127.215C-3.37911 127.215 -6.11842 129.954 -6.11842 133.333C-6.11842 136.712 -3.37911 139.452 1.43051e-06 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 133.333H80V266.667H160V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 139.452C83.3791 139.452 86.1184 136.712 86.1184 133.333C86.1184 129.954 83.3791 127.215 80 127.215C76.6209 127.215 73.8816 129.954 73.8816 133.333C73.8816 136.712 76.6209 139.452 80 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 133.333H160V266.667H240V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 139.452C163.379 139.452 166.118 136.712 166.118 133.333C166.118 129.954 163.379 127.215 160 127.215C156.621 127.215 153.882 129.954 153.882 133.333C153.882 136.712 156.621 139.452 160 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 133.333H240V266.667H320V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 139.452C243.379 139.452 246.118 136.712 246.118 133.333C246.118 129.954 243.379 127.215 240 127.215C236.621 127.215 233.882 129.954 233.882 133.333C233.882 136.712 236.621 139.452 240 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 133.333H320V266.667H400V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 139.452C323.379 139.452 326.118 136.712 326.118 133.333C326.118 129.954 323.379 127.215 320 127.215C316.621 127.215 313.882 129.954 313.882 133.333C313.882 136.712 316.621 139.452 320 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 133.333H400V266.667H480V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 139.452C403.379 139.452 406.118 136.712 406.118 133.333C406.118 129.954 403.379 127.215 400 127.215C396.621 127.215 393.882 129.954 393.882 133.333C393.882 136.712 396.621 139.452 400 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 133.333H480V266.667H560V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 139.452C483.379 139.452 486.118 136.712 486.118 133.333C486.118 129.954 483.379 127.215 480 127.215C476.621 127.215 473.882 129.954 473.882 133.333C473.882 136.712 476.621 139.452 480 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 133.333H560V266.667H640V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 139.452C563.379 139.452 566.118 136.712 566.118 133.333C566.118 129.954 563.379 127.215 560 127.215C556.621 127.215 553.882 129.954 553.882 133.333C553.882 136.712 556.621 139.452 560 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 133.333H640V266.667H720V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 139.452C643.379 139.452 646.118 136.712 646.118 133.333C646.118 129.954 643.379 127.215 640 127.215C636.621 127.215 633.882 129.954 633.882 133.333C633.882 136.712 636.621 139.452 640 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 133.333H720V266.667H800V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 139.452C723.379 139.452 726.118 136.712 726.118 133.333C726.118 129.954 723.379 127.215 720 127.215C716.621 127.215 713.882 129.954 713.882 133.333C713.882 136.712 716.621 139.452 720 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 133.333H800V266.667H880V133.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 139.452C803.379 139.452 806.118 136.712 806.118 133.333C806.118 129.954 803.379 127.215 800 127.215C796.621 127.215 793.882 129.954 793.882 133.333C793.882 136.712 796.621 139.452 800 139.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 266.667H0V400H80V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 272.785C3.37911 272.785 6.11842 270.046 6.11842 266.667C6.11842 263.288 3.37911 260.548 1.43051e-06 260.548C-3.37911 260.548 -6.11842 263.288 -6.11842 266.667C-6.11842 270.046 -3.37911 272.785 1.43051e-06 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 266.667H80V400H160V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 272.785C83.3791 272.785 86.1184 270.046 86.1184 266.667C86.1184 263.288 83.3791 260.548 80 260.548C76.6209 260.548 73.8816 263.288 73.8816 266.667C73.8816 270.046 76.6209 272.785 80 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 266.667H160V400H240V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 272.785C163.379 272.785 166.118 270.046 166.118 266.667C166.118 263.288 163.379 260.548 160 260.548C156.621 260.548 153.882 263.288 153.882 266.667C153.882 270.046 156.621 272.785 160 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 266.667H240V400H320V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 272.785C243.379 272.785 246.118 270.046 246.118 266.667C246.118 263.288 243.379 260.548 240 260.548C236.621 260.548 233.882 263.288 233.882 266.667C233.882 270.046 236.621 272.785 240 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 266.667H320V400H400V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 272.785C323.379 272.785 326.118 270.046 326.118 266.667C326.118 263.288 323.379 260.548 320 260.548C316.621 260.548 313.882 263.288 313.882 266.667C313.882 270.046 316.621 272.785 320 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 266.667H400V400H480V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 272.785C403.379 272.785 406.118 270.046 406.118 266.667C406.118 263.288 403.379 260.548 400 260.548C396.621 260.548 393.882 263.288 393.882 266.667C393.882 270.046 396.621 272.785 400 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 266.667H480V400H560V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 272.785C483.379 272.785 486.118 270.046 486.118 266.667C486.118 263.288 483.379 260.548 480 260.548C476.621 260.548 473.882 263.288 473.882 266.667C473.882 270.046 476.621 272.785 480 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 266.667H560V400H640V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 272.785C563.379 272.785 566.118 270.046 566.118 266.667C566.118 263.288 563.379 260.548 560 260.548C556.621 260.548 553.882 263.288 553.882 266.667C553.882 270.046 556.621 272.785 560 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 266.667H640V400H720V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 272.785C643.379 272.785 646.118 270.046 646.118 266.667C646.118 263.288 643.379 260.548 640 260.548C636.621 260.548 633.882 263.288 633.882 266.667C633.882 270.046 636.621 272.785 640 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 266.667H720V400H800V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 272.785C723.379 272.785 726.118 270.046 726.118 266.667C726.118 263.288 723.379 260.548 720 260.548C716.621 260.548 713.882 263.288 713.882 266.667C713.882 270.046 716.621 272.785 720 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 266.667H800V400H880V266.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 272.785C803.379 272.785 806.118 270.046 806.118 266.667C806.118 263.288 803.379 260.548 800 260.548C796.621 260.548 793.882 263.288 793.882 266.667C793.882 270.046 796.621 272.785 800 272.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 400H0V533.333H80V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 406.118C3.37911 406.118 6.11842 403.379 6.11842 400C6.11842 396.621 3.37911 393.882 1.43051e-06 393.882C-3.37911 393.882 -6.11842 396.621 -6.11842 400C-6.11842 403.379 -3.37911 406.118 1.43051e-06 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 400H80V533.333H160V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 406.118C83.3791 406.118 86.1184 403.379 86.1184 400C86.1184 396.621 83.3791 393.882 80 393.882C76.6209 393.882 73.8816 396.621 73.8816 400C73.8816 403.379 76.6209 406.118 80 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 400H160V533.333H240V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 406.118C163.379 406.118 166.118 403.379 166.118 400C166.118 396.621 163.379 393.882 160 393.882C156.621 393.882 153.882 396.621 153.882 400C153.882 403.379 156.621 406.118 160 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 400H240V533.333H320V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 406.118C243.379 406.118 246.118 403.379 246.118 400C246.118 396.621 243.379 393.882 240 393.882C236.621 393.882 233.882 396.621 233.882 400C233.882 403.379 236.621 406.118 240 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 400H320V533.333H400V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 406.118C323.379 406.118 326.118 403.379 326.118 400C326.118 396.621 323.379 393.882 320 393.882C316.621 393.882 313.882 396.621 313.882 400C313.882 403.379 316.621 406.118 320 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 400H400V533.333H480V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 406.118C403.379 406.118 406.118 403.379 406.118 400C406.118 396.621 403.379 393.882 400 393.882C396.621 393.882 393.882 396.621 393.882 400C393.882 403.379 396.621 406.118 400 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 400H480V533.333H560V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 406.118C483.379 406.118 486.118 403.379 486.118 400C486.118 396.621 483.379 393.882 480 393.882C476.621 393.882 473.882 396.621 473.882 400C473.882 403.379 476.621 406.118 480 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 400H560V533.333H640V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 406.118C563.379 406.118 566.118 403.379 566.118 400C566.118 396.621 563.379 393.882 560 393.882C556.621 393.882 553.882 396.621 553.882 400C553.882 403.379 556.621 406.118 560 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 400H640V533.333H720V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 406.118C643.379 406.118 646.118 403.379 646.118 400C646.118 396.621 643.379 393.882 640 393.882C636.621 393.882 633.882 396.621 633.882 400C633.882 403.379 636.621 406.118 640 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 400H720V533.333H800V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 406.118C723.379 406.118 726.118 403.379 726.118 400C726.118 396.621 723.379 393.882 720 393.882C716.621 393.882 713.882 396.621 713.882 400C713.882 403.379 716.621 406.118 720 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 400H800V533.333H880V400Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 406.118C803.379 406.118 806.118 403.379 806.118 400C806.118 396.621 803.379 393.882 800 393.882C796.621 393.882 793.882 396.621 793.882 400C793.882 403.379 796.621 406.118 800 406.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 533.333H0V666.667H80V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 539.452C3.37911 539.452 6.11842 536.712 6.11842 533.333C6.11842 529.954 3.37911 527.215 1.43051e-06 527.215C-3.37911 527.215 -6.11842 529.954 -6.11842 533.333C-6.11842 536.712 -3.37911 539.452 1.43051e-06 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 533.333H80V666.667H160V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 539.452C83.3791 539.452 86.1184 536.712 86.1184 533.333C86.1184 529.954 83.3791 527.215 80 527.215C76.6209 527.215 73.8816 529.954 73.8816 533.333C73.8816 536.712 76.6209 539.452 80 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 533.333H160V666.667H240V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 539.452C163.379 539.452 166.118 536.712 166.118 533.333C166.118 529.954 163.379 527.215 160 527.215C156.621 527.215 153.882 529.954 153.882 533.333C153.882 536.712 156.621 539.452 160 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 533.333H240V666.667H320V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 539.452C243.379 539.452 246.118 536.712 246.118 533.333C246.118 529.954 243.379 527.215 240 527.215C236.621 527.215 233.882 529.954 233.882 533.333C233.882 536.712 236.621 539.452 240 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 533.333H320V666.667H400V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 539.452C323.379 539.452 326.118 536.712 326.118 533.333C326.118 529.954 323.379 527.215 320 527.215C316.621 527.215 313.882 529.954 313.882 533.333C313.882 536.712 316.621 539.452 320 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 533.333H400V666.667H480V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 539.452C403.379 539.452 406.118 536.712 406.118 533.333C406.118 529.954 403.379 527.215 400 527.215C396.621 527.215 393.882 529.954 393.882 533.333C393.882 536.712 396.621 539.452 400 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 533.333H480V666.667H560V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 539.452C483.379 539.452 486.118 536.712 486.118 533.333C486.118 529.954 483.379 527.215 480 527.215C476.621 527.215 473.882 529.954 473.882 533.333C473.882 536.712 476.621 539.452 480 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 533.333H560V666.667H640V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 539.452C563.379 539.452 566.118 536.712 566.118 533.333C566.118 529.954 563.379 527.215 560 527.215C556.621 527.215 553.882 529.954 553.882 533.333C553.882 536.712 556.621 539.452 560 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 533.333H640V666.667H720V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 539.452C643.379 539.452 646.118 536.712 646.118 533.333C646.118 529.954 643.379 527.215 640 527.215C636.621 527.215 633.882 529.954 633.882 533.333C633.882 536.712 636.621 539.452 640 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 533.333H720V666.667H800V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 539.452C723.379 539.452 726.118 536.712 726.118 533.333C726.118 529.954 723.379 527.215 720 527.215C716.621 527.215 713.882 529.954 713.882 533.333C713.882 536.712 716.621 539.452 720 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 533.333H800V666.667H880V533.333Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 539.452C803.379 539.452 806.118 536.712 806.118 533.333C806.118 529.954 803.379 527.215 800 527.215C796.621 527.215 793.882 529.954 793.882 533.333C793.882 536.712 796.621 539.452 800 539.452Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 666.667H0V800H80V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 672.785C3.37911 672.785 6.11842 670.046 6.11842 666.667C6.11842 663.288 3.37911 660.548 1.43051e-06 660.548C-3.37911 660.548 -6.11842 663.288 -6.11842 666.667C-6.11842 670.046 -3.37911 672.785 1.43051e-06 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 666.667H80V800H160V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 672.785C83.3791 672.785 86.1184 670.046 86.1184 666.667C86.1184 663.288 83.3791 660.548 80 660.548C76.6209 660.548 73.8816 663.288 73.8816 666.667C73.8816 670.046 76.6209 672.785 80 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 666.667H160V800H240V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 672.785C163.379 672.785 166.118 670.046 166.118 666.667C166.118 663.288 163.379 660.548 160 660.548C156.621 660.548 153.882 663.288 153.882 666.667C153.882 670.046 156.621 672.785 160 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 666.667H240V800H320V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 672.785C243.379 672.785 246.118 670.046 246.118 666.667C246.118 663.288 243.379 660.548 240 660.548C236.621 660.548 233.882 663.288 233.882 666.667C233.882 670.046 236.621 672.785 240 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 666.667H320V800H400V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 672.785C323.379 672.785 326.118 670.046 326.118 666.667C326.118 663.288 323.379 660.548 320 660.548C316.621 660.548 313.882 663.288 313.882 666.667C313.882 670.046 316.621 672.785 320 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 666.667H400V800H480V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 672.785C403.379 672.785 406.118 670.046 406.118 666.667C406.118 663.288 403.379 660.548 400 660.548C396.621 660.548 393.882 663.288 393.882 666.667C393.882 670.046 396.621 672.785 400 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 666.667H480V800H560V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 672.785C483.379 672.785 486.118 670.046 486.118 666.667C486.118 663.288 483.379 660.548 480 660.548C476.621 660.548 473.882 663.288 473.882 666.667C473.882 670.046 476.621 672.785 480 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 666.667H560V800H640V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 672.785C563.379 672.785 566.118 670.046 566.118 666.667C566.118 663.288 563.379 660.548 560 660.548C556.621 660.548 553.882 663.288 553.882 666.667C553.882 670.046 556.621 672.785 560 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 666.667H640V800H720V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 672.785C643.379 672.785 646.118 670.046 646.118 666.667C646.118 663.288 643.379 660.548 640 660.548C636.621 660.548 633.882 663.288 633.882 666.667C633.882 670.046 636.621 672.785 640 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 666.667H720V800H800V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 672.785C723.379 672.785 726.118 670.046 726.118 666.667C726.118 663.288 723.379 660.548 720 660.548C716.621 660.548 713.882 663.288 713.882 666.667C713.882 670.046 716.621 672.785 720 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 666.667H800V800H880V666.667Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 672.785C803.379 672.785 806.118 670.046 806.118 666.667C806.118 663.288 803.379 660.548 800 660.548C796.621 660.548 793.882 663.288 793.882 666.667C793.882 670.046 796.621 672.785 800 672.785Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80 800H0V933.333H80V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43051e-06 806.118C3.37911 806.118 6.11842 803.379 6.11842 800C6.11842 796.621 3.37911 793.882 1.43051e-06 793.882C-3.37911 793.882 -6.11842 796.621 -6.11842 800C-6.11842 803.379 -3.37911 806.118 1.43051e-06 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160 800H80V933.333H160V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 806.118C83.3791 806.118 86.1184 803.379 86.1184 800C86.1184 796.621 83.3791 793.882 80 793.882C76.6209 793.882 73.8816 796.621 73.8816 800C73.8816 803.379 76.6209 806.118 80 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240 800H160V933.333H240V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 806.118C163.379 806.118 166.118 803.379 166.118 800C166.118 796.621 163.379 793.882 160 793.882C156.621 793.882 153.882 796.621 153.882 800C153.882 803.379 156.621 806.118 160 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M320 800H240V933.333H320V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 806.118C243.379 806.118 246.118 803.379 246.118 800C246.118 796.621 243.379 793.882 240 793.882C236.621 793.882 233.882 796.621 233.882 800C233.882 803.379 236.621 806.118 240 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400 800H320V933.333H400V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 806.118C323.379 806.118 326.118 803.379 326.118 800C326.118 796.621 323.379 793.882 320 793.882C316.621 793.882 313.882 796.621 313.882 800C313.882 803.379 316.621 806.118 320 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480 800H400V933.333H480V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 806.118C403.379 806.118 406.118 803.379 406.118 800C406.118 796.621 403.379 793.882 400 793.882C396.621 793.882 393.882 796.621 393.882 800C393.882 803.379 396.621 806.118 400 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560 800H480V933.333H560V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 806.118C483.379 806.118 486.118 803.379 486.118 800C486.118 796.621 483.379 793.882 480 793.882C476.621 793.882 473.882 796.621 473.882 800C473.882 803.379 476.621 806.118 480 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M640 800H560V933.333H640V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 806.118C563.379 806.118 566.118 803.379 566.118 800C566.118 796.621 563.379 793.882 560 793.882C556.621 793.882 553.882 796.621 553.882 800C553.882 803.379 556.621 806.118 560 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M720 800H640V933.333H720V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 806.118C643.379 806.118 646.118 803.379 646.118 800C646.118 796.621 643.379 793.882 640 793.882C636.621 793.882 633.882 796.621 633.882 800C633.882 803.379 636.621 806.118 640 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M800 800H720V933.333H800V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 806.118C723.379 806.118 726.118 803.379 726.118 800C726.118 796.621 723.379 793.882 720 793.882C716.621 793.882 713.882 796.621 713.882 800C713.882 803.379 716.621 806.118 720 806.118Z",
    fill: "#4F279B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M880 800H800V933.333H880V800Z",
    stroke: "#4F279B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 806.118C803.379 806.118 806.118 803.379 806.118 800C806.118 796.621 803.379 793.882 800 793.882C796.621 793.882 793.882 796.621 793.882 800C793.882 803.379 796.621 806.118 800 806.118Z",
    fill: "#4F279B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_42268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesDots);
export default __webpack_public_path__ + "static/media/lines-dots.2c14e3072530783c18c4574778c2ceb0.svg";
export { ForwardRef as ReactComponent };